import HTTP from '../HTTP';

export default {
    getCountries() {
        return HTTP.get('/countries');
    },
    createCountry(data) {
        return HTTP.post('/countries', data);
    },
    editCountry(code, data) {
        return HTTP.put(`/countries/${code}`, data);
    },
    removeCountry(code) {
        return HTTP.delete(`/countries/${code}`);
    },
};